import React from 'react';
import './style.scss';
import { Image, Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { renderDate } from '../Shared/Helpers/dateTimeHelper';
import useWindowSize from '../Shared/hooks/useWindowSize';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';

const VideoPlayerComponent = (props) => {
  const {
    youtubeId,
    vimeoId,
    video,
    badges: items,
    heading,
    text,
    subheading: description,
    image: thumbnail,
    author,
    publishingDate,
  } = props?.fields;

  const { params, i18n } = props;
  const lang = i18n.language;

  let videoYoutubeSource = youtubeId?.value;
  let videoVimeoSource = vimeoId?.value;
  let videoSource = video?.value?.src;

  const shoudRenderYoutube = !!videoYoutubeSource && videoYoutubeSource !== '';
  const shoudRenderVimeo = !!videoVimeoSource && videoVimeoSource !== '' && !shoudRenderYoutube;
  const shoudRenderVideo =
    !!videoSource && videoSource !== '' && !shoudRenderVimeo && !shoudRenderYoutube;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderDescription = !!description?.value;
  const shouldRenderAuthor = !!author?.value;
  const shouldRenderPublishingDate = !!publishingDate?.value;
  const shouldRenderText = !!text?.value;
  const shouldRenderItems = !!items && Array.isArray(items) && items.length > 0;

  const [width] = useWindowSize();

  const safeWidth = width || 1200;

  return (
    <div className={clsx('video-component', 'add-margins', params?.Styles)}>
      <div className="video-container">
        {shoudRenderVimeo && (
          <div className="fullscreen">
            <div className="video">
              <div className="wrapper">
                <iframe
                  style={{ minHeight: safeWidth / 1.5 + 'px' }}
                  src={`//player.vimeo.com/video/${videoVimeoSource}?autoplay=1&loop=1&title=0&byline=0&portrait=0`}
                  frameBorder="0"
                  allowFullScreen
                  sandbox
                />
              </div>
            </div>
          </div>
        )}

        {shoudRenderVideo && (
          <div className={`videoItem videop`}>
            <video
              style={{ minHeight: '200px', width: '100%' }}
              controls
              preload="metadata"
              poster={thumbnail?.value?.src}
            >
              <source src={videoSource} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        )}

        {shoudRenderYoutube && (
          <div className={`videoItem youtube`} style={{ minHeight: safeWidth / 2 + 'px' }}>
            <iframe
              style={{ minHeight: safeWidth / 2 + 'px', width: '100%' }}
              src={`//www.youtube.com/embed/${videoYoutubeSource}`}
              frameBorder="0"
              allowFullScreen
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              title="YouTube video player"
            />
          </div>
        )}
      </div>

      <div className={`btn-text-wrap ${!shouldRenderItems ? 'full-width' : ''}`}>
        <div className="flex-it flex-justify-between content text-and-description">
          <div className="text-wrap">
            <div className="title">{shouldRenderHeading && <Text field={heading} />}</div>
            <div className="description">
              {shouldRenderDescription && <RichText field={description} />}
              {shouldRenderText && <RichText field={text} />}
            </div>
            <div className="subText">
              {shouldRenderAuthor && <Text field={author} />} {shouldRenderAuthor && ' . '}
              {shouldRenderPublishingDate &&
                ' Published on ' &&
                renderDate(publishingDate?.value, lang, 'm d, y')}
            </div>
          </div>
          {shouldRenderItems && (
            <div className="links">
              {items.map((item, i) => {
                const fieldLink = item?.fields?.link;
                const shouldRender = fieldLink?.value;
                return (
                  shouldRender && (
                    <div key={i} className="image-item">
                      <Link field={fieldLink} className="csp-card">
                        {item?.fields?.image && <Image field={item?.fields?.image} />}
                      </Link>
                    </div>
                  )
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(VideoPlayerComponent);
